import { useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { IconButton, Loading } from "../../../../components";
import { useImportContext } from "../../../../contexts/import.context";
import {
  CondicionaisService,
  EmailPersonalizadoService,
  NotificacaoService,
  notification,
  SessionService,
} from "../../../../services";
import { voltar } from "../../../../utils";
import EnvioWhatsappDialog from "./dialogComponents/EnvioWhatsappDialog";
import MainPrintLayout from "./MainPrintLayout";

const condicionaisService = new CondicionaisService();
const notificacaoService = new NotificacaoService();
const emailPersonalizadoService = new EmailPersonalizadoService();
const sessionService = new SessionService();

const ButtonMenu = ({
  id,
  data,
  openDialogEnvioWhatsapp,
  setOpenDialogEnvioWhatsapp,
}) => {
  const { initialCollapses } = useImportContext();
  const [loading, setLoading] = useState(false);
  const componentRef = useRef(null);
  const usuario = sessionService.getUsuario();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle: `
        @page {
            size: auto;
            margin: 8mm;
        }
    `,
  });

  const escolhaImpressao = async () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      handlePrint();
      if (!id) {
        initialCollapses();
        voltar();
      }
    }, 1000);
    return;
  };

  const aspectRatioLogoEmpresa = () => {
    const img = document.getElementById("whats");
    const aspectRatio = (img.naturalWidth || 1) / (img.naturalHeight || 1);
    return aspectRatio <= 1.5 ? 100 : 20;
  };

  const enviarEmail = async () => {
    if (data.cliente?.email) {
      setLoading(true);
      try {
        const getPrimeiroNome = (nomeCompleto) => {
          return nomeCompleto?.split(" ")[0] || "";
        };
        const nomeCliente = data?.cliente?.nomeRazaoSocial;
        const resultEmail = await emailPersonalizadoService.getInformacoesEmail({
          contexto: "condicional",
          apelidoFantasia: data?.empresa?.fantasia,
          numeroDocumento: data?.codigo,
          status: data?.status,
          dataVencimento: data?.dataVencimentoFormat,
          nomeCompletoCliente: nomeCliente,
          primeiroNomeCliente: getPrimeiroNome(nomeCliente),
          nomeUsuario: usuario?.nome,
        });
        if (resultEmail.isAxiosError) {
          const message = resultEmail?.response?.data?.message;
          throw new Error(message ?? "Erro interno de servidor");
        }
        
        const {
          subject = "Documento referente a Condicional",
          text = "Segue condicional solicitada em anexo",
        } = resultEmail.data ?? {};

        const aspectRatio = aspectRatioLogoEmpresa();
        const result = await condicionaisService.pdf({
          ...data,
          vendedor: data.vendedor ?? "Sem Vendedor",
          empresa: {
            ...data.empresa,
            aspectRatio,
          },
        });
        if (!result || result.isAxiosError) {
          const message = resultEmail?.response?.data?.message;
          throw new Error(message ?? "Erro interno de servidor");
        }

        const anexo = {
          filename: result.data.docName,
          type: "application/pdf",
          content: result.data.file,
        };
        const resultEnvio = await notificacaoService.enviarEmail({
          to: data.cliente.email,
          subject,
          text,
          attachments: [anexo],
        });
        if (!resultEnvio.isAxiosError) {
          notification.sucessoGenericos("Documento enviado com sucesso");
        } else {
          throw new Error("Erro ao enviar documento via email");
        }
      } catch (error) {
        console.error(error);
        notification.alertaGenericos(error.message);
      } finally {
        setLoading(false);
        initialCollapses();
        if (!id) voltar();
      }
    } else {
      notification.alertaGenericos("Este cliente não possui e-mail cadastrado");
      initialCollapses();
      if (!id) voltar();
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-center">
      <img
        id="whats"
        className="d-none me-3"
        src={data?.imagemLogo}
        alt="logo da empresa"
      />
      <div className={!id && "d-none"}>
        <div className="d-none">
          <div ref={componentRef}>
            <MainPrintLayout data={data} />
          </div>
        </div>
        <IconButton
          id="botaoMenuAction"
          onClick={escolhaImpressao}
          size="small"
          sx={{ marginLeft: 1.5 }}
        >
          <i className="ph-fill ph-printer" style={{ fontSize: 18 }}></i>
        </IconButton>
        <IconButton
          id="botaoEmailAction"
          onClick={enviarEmail}
          size="small"
          sx={{ marginLeft: 1.5 }}
        >
          <i className="ph-fill ph-envelope" style={{ fontSize: 18 }}></i>
        </IconButton>
        <IconButton
          onClick={() => setOpenDialogEnvioWhatsapp(true)}
          size="small"
          sx={{ marginLeft: 1.5 }}
        >
          <i
            className="ph-fill ph-whatsapp-logo"
            style={{ fontSize: 18, color: "#48A34C" }}
          ></i>
        </IconButton>
      </div>
      <EnvioWhatsappDialog
        open={openDialogEnvioWhatsapp}
        setOpen={setOpenDialogEnvioWhatsapp}
        data={data}
        initialCollapses={initialCollapses}
      />
      <Loading loading={loading} />
    </div>
  );
};

export default ButtonMenu;
